export enum EventTypes {
  KEYS_DELIVERY = 'keysDelivery',
  VISIT_TO_CONSTRUCTION = 'visitToConstruction',
}

export enum PresenceStatus {
  CANCELLED,
  CONFIRMED,
  NONE,
}

export interface DialogContent {
  title: string
  body: string
  buttonTexts?: string[]
  onPressConfirm: () => void
  onPressDismiss: () => void
}

export interface KeysDeliveryIds {
  invitationId: string
  eventId: string
}
